import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import "./ArrowButton.css";

type ArrowButtonProps = {
  to?: string;
  href?: string;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: "pink" | "navy" | "white";
  size?: "sm" | "md" | "lg";
  icon?: "arrow" | "external";
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

export default function ArrowButton({
  to,
  href,
  onClick,
  type = "button",
  variant = "pink",
  size = "md",
  icon = "arrow",
  disabled,
  className = "",
  children,
}: ArrowButtonProps) {
  const classes = `cz-arrow-btn cz-arrow-btn--${variant} cz-arrow-btn--${size} ${className}`.trim();
  const Icon = icon === "external" ? ArrowUpRight : ArrowRight;
  const content = (
    <>
      <span className="cz-arrow-btn__label">{children}</span>
      <span className="cz-arrow-btn__circle" aria-hidden="true">
        <Icon size={size === "sm" ? 16 : 18} strokeWidth={2} />
      </span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick}>
        {content}
      </Link>
    );
  }

  if (href) {
    const external = /^https?:\/\//.test(href);
    return (
      <a
        href={href}
        className={classes}
        onClick={onClick}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {content}
      </a>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled}>
      {content}
    </button>
  );
}
